import { useQueryParams } from 'use-query-params'

export default function useSetQuery() {
  return { setQuery: useQueryParams({})[1] }
}
